import { createTheme } from '@mui/material/styles';

/**
 * Paleta da marca Identila (mesma do entry-onboarding): plum é superfície,
 * violet é ação, lime é marcador.
 */
export const COLORS = {
  background: '#F7F7F2',
  text: '#171918',
  violet: '#8A3FD0',
  plum: '#48204F',
  lime: '#D5F919',
  limeSoft: '#F1FDB4',
  line: '#E4E2DA',
} as const;

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: COLORS.violet },
    secondary: { main: COLORS.lime, contrastText: COLORS.text },
    text: { primary: COLORS.text },
    background: { default: COLORS.background, paper: '#ffffff' },
  },
  typography: {
    fontFamily: '"Outfit", system-ui, sans-serif',
    h1: { fontSize: 28, fontWeight: 700, letterSpacing: -0.5, lineHeight: 1.2 },
    h2: { fontSize: 22, fontWeight: 700, lineHeight: 1.25 },
    body1: { fontSize: 16, lineHeight: 1.5 },
    body2: { fontSize: 14, lineHeight: 1.45 },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 28, minHeight: 56, fontSize: 16 },
      },
    },
    MuiTextField: {
      defaultProps: { fullWidth: true, margin: 'normal' },
    },
  },
});
